
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11204",
                "data-name": "矩形 11204",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(331 319)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_244",
        "data-name": "蒙版组 244",
        "class": "cls-2",
        "transform": "translate(-331 -319)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "_041雨伞",
            "data-name": "041雨伞",
            "class": "cls-3",
            "d": "M61.3,12.266a7.67,7.67,0,0,0-.668-3.139,8.031,8.031,0,0,0-1.822-2.563,8.495,8.495,0,0,0-2.7-1.728,8.811,8.811,0,0,0-2.9-.625.327.327,0,0,0,0-.043V2.891a.413.413,0,0,0-.825,0V4.169a.327.327,0,0,0,0,.043,8.8,8.8,0,0,0-2.9.625,8.516,8.516,0,0,0-2.7,1.728,8.011,8.011,0,0,0-1.822,2.563,7.67,7.67,0,0,0-.668,3.139v.391h8.089a.227.227,0,0,0,0,.036v6.138a.936.936,0,0,1-1.868,0,.413.413,0,0,0-.825,0,1.762,1.762,0,0,0,3.519,0V12.693a.227.227,0,0,0,0-.036H61.3Zm-16.163-.391a6.906,6.906,0,0,1,.593-2.442A7.274,7.274,0,0,1,47.375,7.12a7.661,7.661,0,0,1,2.439-1.561,8.093,8.093,0,0,1,5.973,0A7.713,7.713,0,0,1,58.225,7.12a7.226,7.226,0,0,1,1.645,2.313,6.9,6.9,0,0,1,.593,2.442Z",
            "transform": "translate(290.2 320)"
          }
        }
      ]
    }
  ]
})
    }
  